import React, {useState} from "react";

import {useTranslation} from "react-i18next";
import {MergePlanPopup} from "../modal/MergePlanPopup";
import {ShiftPlanPopup} from "../modal/ShiftPlanPopup";
import {CreatePlanPopup} from "features/plan/components/modal/CreatePlanPopup";
import {isUpdateDisabled} from "shared/lib/fns";
import {Button, useModal, useToast} from "shared/ui";
import {IPlanLongItem, PlanSearchParamKey} from "features/plan/types";
import {useSearchParams} from "react-router-dom";

interface Props {
  onUpdated: (type: "merge" | "shift" | "create") => void;
  selectedPlans: IPlanLongItem[];
  selectedTrackings: string[];
  planNo?: string;
  planDate?: string;
}

export const PlanControlButtons = ({
                                     selectedPlans, selectedTrackings, onUpdated,
                                   }: Props) => {
  const {t} = useTranslation("shipping");
  const toast = useToast();
  const modal = useModal();
  const [params] = useSearchParams();
  const [isVisibleMerging, setMergingVisibility] = useState(false);
  const [isVisibleShifting, setShiftingVisibility] = useState(false);
  const [isVisibleCreation, setCreationVisibility] = useState(false);
  const planNo = params.get(PlanSearchParamKey.planNo)
  const planDate = params.get(PlanSearchParamKey.planDate)
  
  const handleCreatePlan = () => {
    if (!params.get(PlanSearchParamKey.planNo)) {
      toast.warning(t("Please, select plan no first"));
      return;
    }
    if (!!selectedTrackings && selectedTrackings.length > 0) {
      setCreationVisibility(true);
      return
    }
    toast.warning(t("popup.error.empty"));
  };
  
  const containUpdateDisabledShippings = (plan: IPlanLongItem) => {
    return (!plan.shippingitems_geo || plan.shippingitems_geo.filter((geo) => isUpdateDisabled(geo.shipping_item__status, geo.is_scanned)).length);
  }
  
  const handleMergePlan = () => {
    if (!!selectedPlans && selectedPlans.length > 0) {
      if (selectedPlans.length === 1) {
        if (containUpdateDisabledShippings(selectedPlans[0])) {
          toast.warning(t("Please, select a plan not sorted"));
        }
        else {
          setMergingVisibility(true);
        }
      }
      else {
        toast.warning(t("Please, select only one plan to merge"));
      }
    }
    else {
      toast.warning(t("Please, select plan"));
    }
  };
  
  const handleShiftShipping = () => {
    if (!!selectedTrackings && selectedTrackings.length > 0) {
      setShiftingVisibility(true);
    }
    else {
      toast.warning(t("popup.error.empty"));
    }
  };
  
  const handleMerged = () => {
    setMergingVisibility(false);
    modal.info({children: t("Plans were merged successfully")});
    onUpdated("merge");
  }
  
  const handleShifted = () => {
    setShiftingVisibility(false);
    modal.info({children: t("Shippings were shifted successfully")});
    onUpdated("shift");
  }
  
  const handleCreated = () => {
    setCreationVisibility(false);
    modal.info({
      children: t("Plan was created successfully")
    });
    onUpdated("create");
  }
  
  return (<div className={"flex gap-[1px]"}>
    <Button
      variant={"primary"}
      size={"sm"}
      style={{height: 32, borderRadius: 2}}
      onClick={handleCreatePlan}
    >
      {t("create plan")}
    </Button>
    <Button
      variant={"primary"}
      size={"sm"}
      style={{height: 32, borderRadius: 2}}
      onClick={handleMergePlan}
    >
      {t("merge plan")}
    </Button>
    <Button
      variant={"primary"}
      size={"sm"}
      style={{height: 32, borderRadius: 2}}
      onClick={handleShiftShipping}
    >
      {t("shift shipping")}
    </Button>
    {isVisibleMerging && selectedPlans && selectedPlans?.length > 0 && (<MergePlanPopup
      srcPlan={selectedPlans[0]}
      onMerged={handleMerged}
      onHide={() => setMergingVisibility(false)}
    />)}
    {isVisibleShifting && selectedTrackings && selectedTrackings?.length > 0 && (<ShiftPlanPopup
      trackingNumbers={selectedTrackings}
      onShifted={handleShifted}
      onHide={() => setShiftingVisibility(false)}
    />)}
    {isVisibleCreation && selectedTrackings && selectedTrackings?.length > 0 && (<CreatePlanPopup
      trackingNumbers={selectedTrackings}
      planNo={planNo}
      planDate={planDate}
      onCreated={handleCreated}
      onHide={() => setCreationVisibility(false)}
    />)}
  </div>);
};
